import { Outlet } from 'react-router';

export default function ProtectedPageLayout() {
    return (
        <>
            {/* <div style={{backgroundColor: 'rgb(38, 63, 73)', height: '60px'}}>
            <NavbarSmall items={NavItemsProtected}/>
        </div> */}
            <Outlet />
            {/* <Footer/> */}
        </>
    );
}
